import {
  AdminService,
  ClientService,
  DropboxService,
  JobTypeService,
  ProjectJobService,
  ProjectPermitTaskService,
  ProjectService,
  ProjectSurveyTaskService,
  SettingsService,
  TimeTrackingService,
  UserService,
} from '@vmspdb/definitions';
import { createClientToken } from './connect.module';

export const ConnectUser = createClientToken(UserService);
export const ConnectAdmin = createClientToken(AdminService);
export const ConnectClient = createClientToken(ClientService);
export const ConnectDropbox = createClientToken(DropboxService);
export const ConnectJobType = createClientToken(JobTypeService);
export const ConnectProjectJob = createClientToken(ProjectJobService);
export const ConnectProjectPermitTask = createClientToken(
  ProjectPermitTaskService,
);
export const ConnectProject = createClientToken(ProjectService);
export const ConnectProjectSurveyTask = createClientToken(
  ProjectSurveyTaskService,
);
export const ConnectSettings = createClientToken(SettingsService);
export const ConnectTimeTracking = createClientToken(TimeTrackingService);
